import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { FileService } from '../services/file.service';
import { Documento, AttachmentDto, ProcessoRiferimento, DocumentiEqualtecResult, DocumentiEqualtecResultObject, LegalEntityEprocessiRiferimentoResult, Evidenza } from '../models/data.model';
import { DataService } from '../services/data.service';
import { CommonService } from '../services/common.service';
import { MimetypeService } from '../services/mimetype.service';
import { TranslateService } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ElementRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-equaltec',
  templateUrl: './equaltec.component.html',
  styleUrls: ['./equaltec.component.css']
})

export class EqualtecComponent implements OnInit {
  @ViewChild('Or') OrElement;
  @ViewChild('And') AndElement;
  @ViewChild('DynamicForm') DynamicFormElement;
  @ViewChild('DynamicInput') DynamicInputElement;
  @ViewChild('fileUpload') myInputVariable: ElementRef;

  constructor(private tipologiService: FileService,
    private dataService: DataService,
    private documentService: CommonService<Documento>,
    private evidenzaService: CommonService<Evidenza>,
    private creaEvidenzaService: CommonService<string>,
    private processoRiferimentoService: CommonService<LegalEntityEprocessiRiferimentoResult>,
    private documentiEqualtecResultService: CommonService<DocumentiEqualtecResult>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    public translate: TranslateService,
    private http: HttpClient
  ) { }


  //Gestione HOME 
  isMultiLegalEntity: boolean = false
  isScrittaLaterale: boolean = false;
  isFilter: boolean = false;
  isExpandedSearch: boolean = false;
  changeLegalEntityButton: boolean = true
  ngDropdown = "QA Esaote SpA";
  checkBoxValue: string = 'and';
  searchCodice: string;
  searchOggetto: string;
  searchFullText: string;

  ngOptions: string[] = [];
  processi: ProcessoRiferimento[] = [];
  processiSopra: ProcessoRiferimento[] = [];
  processiCentrale: ProcessoRiferimento[] = [];
  processiSotto: ProcessoRiferimento[] = [];

  documents: Documento[] = [];
  isDetailSearch = false;
  labelNoRecord: boolean = false;
  isLegalentityTitleInterno: boolean = false;
  docApertiSearch: number = 0;
  isTabellaSearchRevisionPending: boolean = false;
  // FINE //Gestione HOME

  srch: Documento = null;
  public equaltecFilter: any = '';
  legalEntityEprocessiRiferimentoResult: LegalEntityEprocessiRiferimentoResult;
  sottoprocessi: string[] = [];
  documentiEqualtecResult: DocumentiEqualtecResult[] = [];
  documentiEqualtecResultProcess: DocumentiEqualtecResult[] = [];
  documentiEqualtecResultGuideline: DocumentiEqualtecResult[] = [];
  documentsPreferiti: Documento[] = [];
  evidenze: Evidenza[] = [];
  evidenzeRevPrecedente: Evidenza[] = [];
  documentiCollegati: Documento[] = [];
  tabelleProcessiIdentificazioneDocumento: DocumentiEqualtecResultObject[] = [];
  tabelleProcessiIdentificazioneDocumentoOrdered: DocumentiEqualtecResultObject[] = [];
  documentiEqualtecResultBackup: DocumentiEqualtecResult[] = [];

  calendarModel: NgbDateStruct;
  isCalendar: boolean = false;
  openProcess: boolean = true;
  openGuideline: boolean = true;
  isDetail: boolean = false;
  documentiSottoprocessi: boolean = false;
  isDeafaultRecordFilter: boolean = true;
  isUnderlined: string;
  isTabellaSearchConUnElemento: boolean = false;
  isTabellaPreferitiConUnElemento: boolean = false;
  isTabellaLinkConUnElemento: boolean = false;
  isTabellaProcessConUnElemento: boolean = false;
  isTabellaGuidelineConUnElemento: boolean = false;
  isTabellaProcessRevisionPending: boolean = false;
  isTabellaPreferitiRevisionPending: boolean = false;
  isTabellaLinkRevisionPending: boolean = false;
  isTabellaGuidelineRevisionPending: boolean = false;
  isExpandedGuideline: boolean = false;
  isExpandedProcess: boolean = false;
  isExpandedPreferiti: boolean = false;
  isExpandedLink: boolean = false;
  isOkDescrizione: boolean = true;
  isOkOggetto: boolean = true;
  paginaEvidenze: boolean = false;
  isNewRevisionPendingEvidenze: boolean = false;
  paginaEvidenzeSearch: boolean = false;
  paginaEvidenzePreferiti: boolean = false;
  paginaEvidenzeRevPrecedente: boolean = false;
  paginaDocCollegati: boolean = false;
  isEvidenzAccettata: boolean = false;
  paginaDescrizioneDocumentoCorrente: string = "";
  paginaIDDocumentoCorrente: string = "";
  paginaCommittenteDocumentoCorrente: string = "";
  docApertiGuideline: number = 0;
  docApertiProcess: number = 0;
  docApertiPreferiti: number = 0;
  docApertiLink: number = 0;
  filter: string = "All models"
  headerDetail: string;
  selectedDate: Date;
  isDetailPreferiti: boolean = false;
  isDetailSearchEvidenze: boolean = false;
  isDetailPreferitiEvidenze: boolean = false;
  DescrizioneEvidenza: string;
  OggettoEvidenza: string;
  searchFullTextEvidenze: string;
  buttonEvidenzaActive: boolean = true;

  ngOnInit() {
    this.caricaLegalEntityEProcessidiRiferimento();
    // Questo è veramente un casino:
    // quanto viene caricato service-ita.component tramite il routing personale del modulo, si inserisce nel dataService il nome del titolo del componente
    // a questo ComponentInput si sottoscrive il padre di di service-ita, cioè custom-layout.component, che renderizza il titolo in alto
    this.dataService.ComponentInput = '';
  }

  private isExternalDocumentType(identificazioneDocumento: string): boolean {
    const documentType = (identificazioneDocumento || '').trim().toLowerCase();
    return documentType === 'process' || documentType === 'guideline';
  }

  get hasProcessDocuments(): boolean {
    return this.documentiEqualtecResultProcess.length > 0;
  }

  get hasGuidelineDocuments(): boolean {
    return this.documentiEqualtecResultGuideline.length > 0;
  }

  private documentBelongsToSubprocess(documento: DocumentiEqualtecResult, nomeSottoprocesso: string): boolean {
    return (documento.nomeSottoprocesso || '')
      .split(',')
      .map(sottoprocesso => sottoprocesso.trim())
      .includes((nomeSottoprocesso || '').trim());
  }

  //Gestione HOME 
  caricaLegalEntityEProcessidiRiferimento() {
    const url = 'api/rest/CaricaLegalEntityEProcessidiRiferimento';
    const input = { legalEntity: this.ngDropdown };
    this.processoRiferimentoService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.isScrittaLaterale = true;
        const resultLegalEntityEprocessiRiferimentoResult = result as LegalEntityEprocessiRiferimentoResult;
        this.processi = resultLegalEntityEprocessiRiferimentoResult.processiRiferimentoDto;
        this.ngOptions = resultLegalEntityEprocessiRiferimentoResult.legalEntities;
        this.ngDropdown = resultLegalEntityEprocessiRiferimentoResult.legalEntitiesSelected;
        if (this.ngOptions.length > 1) {
          this.isMultiLegalEntity = true;
        }
        this.processiSopra = this.processi.filter(d => d.posizione === 1);
        this.processiCentrale = this.processi.filter(d => d.posizione === 2);
        this.processiSotto = this.processi.filter(d => d.posizione === 3);
      }
    }, error => console.error('error on get Processi di Riferimento', error));
  }
  changeLegalEntityButtonMethod = () => {
    this.changeLegalEntityButton = !this.changeLegalEntityButton;
  }
  changeLegalEntity = () => {
    this.caricaLegalEntityEProcessidiRiferimento(); // La legal entity scelta dall'utente è nell'input della post
  }
  isFilterFunc(): void {
    this.isFilter = !this.isFilter;
  }
  onCheckBoxChange(CheckBoxValue: string): void {
    if (CheckBoxValue != null && CheckBoxValue != undefined && CheckBoxValue != "") {
      if (CheckBoxValue == 'and') {
        this.OrElement.nativeElement.checked = false;
      }
      if (CheckBoxValue == 'or') {
        this.AndElement.nativeElement.checked = false;
      }
      this.checkBoxValue = CheckBoxValue;
    }
  }
  onResultClicked = () => {
    this.isDetailSearch = true;
    let customtag = "";
    if (this.searchCodice) {
      customtag += "Codice," + this.searchCodice;
    }
    if (this.searchOggetto) {
      customtag += this.searchCodice != '' ? "#" : "";
      customtag += "Descrizione," + this.searchOggetto;
    }
    return this.showResult(customtag, this.searchFullText, this.searchOggetto);
  }
  showResult = (customtag: string, textTosearch: string, nomeAllegato: string) => {
    this.labelNoRecord = false;
    this.isTabellaSearchRevisionPending = false;
    this.isExpandedSearch = false;
    const url = 'api/rest/LoadFilteredEqualtecDocuments';
    if (this.checkBoxValue == null) {
      this.checkBoxValue = 'and';
    }
    console.log(this.ngDropdown)
    const input = { customtag: customtag, fulltextquery: textTosearch, conjunction: this.checkBoxValue, filtrolegalEntity: this.ngDropdown };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.isLegalentityTitleInterno = true;

        this.docApertiSearch = 0;
        console.log('this is documents : ', result);
        this.documents = result as Documento[];
        this.documents.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaSearchRevisionPending = true;
          }
        });
      }
      this.labelNoRecord = true;
    })
  }

  //TODO: la show preferiti ci serve come base per quando costruiamo la pagina dedicata
  showResultPreferiti = () => {
    this.docApertiPreferiti = 0;
    this.labelNoRecord = false;
    this.isDetailPreferiti = true;
    this.isDetailSearch = false;
    this.isTabellaPreferitiRevisionPending = false;
    this.isExpandedPreferiti = false;

    const url = 'api/rest/GetDocumentiPreferiti';
    const input = {};
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.isLegalentityTitleInterno = true;

        console.log('this is documents : ', result);
        this.documents = result as Documento[];

        this.documents.forEach(d => {
          d.metadatiDtoList.forEach(p => {
            if (p.key == "StatoDocumento") {
              if (p.value == "RELEASED") {
                this.documentsPreferiti.push(d);
              }
            }
          })
        });

        this.documentsPreferiti.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaPreferitiRevisionPending = true;
          }
        });
        this.labelNoRecord = true;
      }
    })
  }

  openDetail = (idProcessoRiferimento, nomeProcessoRiferimento) => {
    this.headerDetail = nomeProcessoRiferimento;
    this.isDetail = true;
    this.caricaSottoprocessiEdocumenti(nomeProcessoRiferimento, this.ngDropdown);
  }
  // FINE //Gestione HOME

  apriPaginaEvidenze = (idDocumento, descrizioneDocumento, committente, isnewrevisionpending, type) => {
    this.labelNoRecord = false;
    this.isDetail = false;
    this.isDetailSearch = false;
    this.isDetailPreferiti = false;
    if (type == 'search') {
      this.paginaEvidenzeSearch = true;
    } else if (type == 'preferiti') {
      this.paginaEvidenzePreferiti = true;
    } else {
      this.paginaEvidenze = true;
    }
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;
    this.paginaIDDocumentoCorrente = idDocumento;
    this.isNewRevisionPendingEvidenze = isnewrevisionpending;
    this.paginaCommittenteDocumentoCorrente = committente;
    const url = 'api/rest/GetEvidenzeByIdDocumento';
    const input = { iddocumento: idDocumento };
    this.evidenzaService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is evidenze : ', result);
        this.evidenze = result as Evidenza[];
        this.evidenze.forEach(evi => {
          if (evi["stato"] == 2) {
            this.isEvidenzAccettata = true;
          }
        })
        this.labelNoRecord = true;
      }
    });
  }

  apriPaginaEvidenzeRevPrecedente = (idDocumento, descrizioneDocumento, committente) => {
    this.labelNoRecord = false;
    this.isDetail = false;
    this.paginaEvidenzeRevPrecedente = true;
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;
    this.paginaIDDocumentoCorrente = idDocumento;
    this.paginaCommittenteDocumentoCorrente = committente;
    const url = 'api/rest/GetEvidenzeRevPrecedenteByIdDocumento';
    const input = { iddocumento: idDocumento };
    this.evidenzaService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.evidenzeRevPrecedente = result as Evidenza[];
        this.evidenzeRevPrecedente.forEach(evi => {
          if (evi["stato"] == 2) {
            this.isEvidenzAccettata = true;
          }
        })
        this.labelNoRecord = true;
      }
    });
  }

  chiudiPaginaEvidenzeSearch = () => {
    this.isDetailSearch = true;
    this.paginaEvidenzeSearch = false;
  }

  chiudiPaginaEvidenzePreferiti = () => {
    this.isDetailPreferiti = true;
    this.paginaEvidenzePreferiti = false;
  }

  chiudiPaginaEvidenzeEDocCollegati = () => {
    this.isDetail = true;
    this.paginaEvidenze = false;
    this.paginaEvidenzeRevPrecedente = false;
    this.paginaDocCollegati = false;
  }

  apriPaginaDocCollegati = (idDocumento, descrizioneDocumento) => {
    this.docApertiLink = 0;
    this.labelNoRecord = false;
    this.isDetail = false;
    this.isExpandedLink = false;
    this.paginaDocCollegati = true;
    this.isTabellaLinkRevisionPending = false;
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;
    const url = 'api/rest/GetDocumentiCollegatiByIdDocumento';
    const input = { iddocumento: idDocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is documents : ', result);

        this.documentiCollegati = result as Documento[];
        this.documentiCollegati.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
        });
        this.labelNoRecord = true;
      }
    })
  }

  documentDetail = (apridettaglio, descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline) => {
    if (apridettaglio == "Open detail") {
      this.openDocumentDetail(descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    } else {
      this.closeDocumentDetail(descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    }
  }

  openDocumentDetail = (descr, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "search": {
      this.docApertiSearch++;
        let documentiAperti = 0;
        this.isExpandedSearch = true;
        this.documents.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaSearchRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documents.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaSearchRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaSearchConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.documents.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documents.length && this.documents.length > 1) {
          this.isTabellaSearchConUnElemento = true;
          this.documents.forEach(doc => {
            const spl = this.isTabellaSearchRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      case "preferiti": {
        this.docApertiPreferiti++;
        let documentiAperti = 0;
        this.isExpandedPreferiti = true;
        this.documentsPreferiti.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaPreferitiRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documentsPreferiti.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaPreferitiRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaPreferitiConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.documentsPreferiti.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentsPreferiti.length && this.documentsPreferiti.length > 1) {
          this.isTabellaPreferitiConUnElemento = true;
          this.documentsPreferiti.forEach(doc => {
            const spl = this.isTabellaPreferitiRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        this.docApertiLink++;
        let documentiAperti = 0;
        this.isExpandedLink = true;
        this.documentiCollegati.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documentiCollegati.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaLinkRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaLinkConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = true;
          this.documentiCollegati.forEach(doc => {
            const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      case "process": {
        this.docApertiProcess++;
        let documentiAperti = 0;
        this.isExpandedProcess = true;
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.isNewRevisionPending) {
            this.isTabellaProcessRevisionPending = true;
          }
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoList;
            if (this.documentiEqualtecResultProcess.length > 1) {
              const y = { key: '', value: '' }
              doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
              doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaProcessRevisionPending) {
                doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaProcessConUnElemento = true;
            }
            doc.documentoWSDto.apriDettaglio = "Close detail";
          }
        })
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiEqualtecResultProcess.length && this.documentiEqualtecResultProcess.length > 1) {
          this.isTabellaProcessConUnElemento = true;
          this.documentiEqualtecResultProcess.forEach(doc => {
            const spl = this.isTabellaProcessRevisionPending ? 3 : 2;
            doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      case "guideline": {
        this.docApertiGuideline++;
        let documentiAperti = 0;
        this.isExpandedGuideline = true;
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.isNewRevisionPending) {
            this.isTabellaGuidelineRevisionPending = true;
          }
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoList;
            if (this.documentiEqualtecResultGuideline.length > 1) {
              const y = { key: '', value: '' }
              doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
              doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaGuidelineRevisionPending) {
                doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaGuidelineConUnElemento = true;
            }
            doc.documentoWSDto.apriDettaglio = "Close detail";
          }
        })
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiEqualtecResultGuideline.length && this.documentiEqualtecResultGuideline.length > 1) {
          this.isTabellaGuidelineConUnElemento = true;
          this.documentiEqualtecResultGuideline.forEach(doc => {
            const spl = this.isTabellaGuidelineRevisionPending ? 3 : 2;
            doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
          })
        } break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          let documentiAperti = 0;
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.isTabellaAperta = true;
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.isNewRevisionPending) {
                tab.isTabellaRevisionPending = true;
                return;
              }

            })
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoList;
                if (tab.documentiEqualtecResultList.length > 1) {
                  const y = { key: '', value: '' }
                  doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
                  doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
                  if (tab.isTabellaRevisionPending) {
                    doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
                  }
                } else {
                  tab.isTabellaConUnElemento = true;
                }
                doc.documentoWSDto.apriDettaglio = "Close detail";
              }
            })
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.apriDettaglio == "Close detail")
                documentiAperti++;
            })
            if (documentiAperti == tab.documentiEqualtecResultList.length && tab.documentiEqualtecResultList.length > 1) {
              tab.isTabellaConUnElemento = true;
              tab.documentiEqualtecResultList.forEach(doc => {
                const spl = tab.isTabellaRevisionPending ? 3 : 2;
                doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
              })
            }
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }

  closeDocumentDetail = (descr, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "search": {
        let documentiApertiFull = 0;
        this.documents.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documents.length && this.documents.length > 1) {
          this.isTabellaSearchConUnElemento = false;
          this.documents.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaSearchRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiSearch--;
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.documents.length > 1) {
              const spl = this.isTabellaSearchRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiSearch == 0) {
          this.isExpandedSearch = false;
        }
        break;
      }
      case "preferiti": {
        let documentiApertiFull = 0;
        this.documentsPreferiti.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentsPreferiti.length && this.documentsPreferiti.length > 1) {
          this.isTabellaPreferitiConUnElemento = false;
          this.documentsPreferiti.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaPreferitiRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiPreferiti--;
        this.documentsPreferiti.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.documentsPreferiti.length > 1) {
              const spl = this.isTabellaPreferitiRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiPreferiti == 0) {
          this.isExpandedPreferiti = false;
        }
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        let documentiApertiFull = 0;
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = false;
          this.documentiCollegati.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaLinkRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiLink--;
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.documentiCollegati.length > 1) {
              const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiLink == 0) {
          this.isExpandedLink = false;
        }
        break;
      }
      case "process": {
        let documentiApertiFull = 0;
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiEqualtecResultProcess.length && this.documentiEqualtecResultProcess.length > 1) {
          this.isTabellaProcessConUnElemento = false;
          this.documentiEqualtecResultProcess.forEach(doc => {
            const y = { key: '', value: '' }
            doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
            doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaProcessRevisionPending) {
              doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiProcess--;
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            if (this.documentiEqualtecResultProcess.length > 1) {
              const spl = this.isTabellaProcessRevisionPending ? 3 : 2;
              doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
            }
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoShortList;
            doc.documentoWSDto.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiProcess == 0) {
          this.isExpandedProcess = false;
        }
        break;
      }
      case "guideline": {
        let documentiApertiFull = 0;
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiEqualtecResultGuideline.length && this.documentiEqualtecResultGuideline.length > 1) {
          this.isTabellaGuidelineConUnElemento = false;
          this.documentiEqualtecResultGuideline.forEach(doc => {
            const y = { key: '', value: '' }
            doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
            doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaGuidelineRevisionPending) {
              doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiGuideline--;
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            if (this.documentiEqualtecResultGuideline.length > 1) {
              const spl = this.isTabellaGuidelineRevisionPending ? 3 : 2;
              doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
            }
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoShortList;
            doc.documentoWSDto.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiGuideline == 0) {
          this.isExpandedGuideline = false;
        }
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            let documentiApertiFull = 0;
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.apriDettaglio == "Close detail")
                documentiApertiFull++;
            })
            if (documentiApertiFull == tab.documentiEqualtecResultList.length && tab.documentiEqualtecResultList.length > 1) {
              tab.isTabellaConUnElemento = false;
              tab.documentiEqualtecResultList.forEach(doc => {
                const y = { key: '', value: '' }
                doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
                doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
                if (tab.isTabellaRevisionPending) {
                  doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
                }
              })
            }
            let documentiAperti = 0;
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {

                if (tab.documentiEqualtecResultList.length > 1) {
                  const spl = tab.isTabellaRevisionPending ? 3 : 2;
                  doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
                }
                doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoShortList;
                doc.documentoWSDto.apriDettaglio = "Open detail";
              }
            })
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.apriDettaglio == "Close detail")
                documentiAperti++;
            })
            if (documentiAperti == 0) {
              tab.isTabellaAperta = false;
            }
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }
 
  caricaSottoprocessiEdocumenti(nomeProcessoRiferimento, legalEntityCorrente) {
    this.isDeafaultRecordFilter = true;
    this.labelNoRecord = false;
    this.documentiEqualtecResultProcess = [];
    this.documentiEqualtecResultGuideline = [];
    this.isTabellaProcessRevisionPending = false;
    this.isTabellaGuidelineRevisionPending = false;
    const url = 'api/rest/caricaSottoprocessiEdocumenti';
    const input = { processoRiferimento: nomeProcessoRiferimento, filtrolegalEntity: legalEntityCorrente };  // Attenzione così gestisce un solo filtro. Per più di un filtro usare '#' come separatore filtri
    this.documentiEqualtecResultService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.sottoprocessi = []; // Fix Ticket 104207
        this.isLegalentityTitleInterno = true;
        console.log(result)
        this.documentiEqualtecResult = result as DocumentiEqualtecResult[];
        let total = {}
        this.documentiEqualtecResult.forEach(d => {
          if (!this.isExternalDocumentType(d.identificazioneDocumento)) {
            let sottoprocessiList = [];
            sottoprocessiList = (d.nomeSottoprocesso || '').split(',').map(sottoprocesso => sottoprocesso.trim())
            sottoprocessiList.forEach(k => {
              if (k != "NA" && k != "" && k != null && k != undefined && !this.sottoprocessi.includes(k)) {
                this.sottoprocessi.push(k);
              }
            }
            )
          }
          d.documentoWSDto.metadatiDtoViewList = d.documentoWSDto.metadatiDtoShortList;
          d.documentoWSDto.apriDettaglio = "Open detail";
          if (this.isExternalDocumentType(d.identificazioneDocumento)) {
            if (d.identificazioneDocumento == "Process") {
              if (d.documentoWSDto.isNewRevisionPending) {
                this.isTabellaProcessRevisionPending = true;
              }
              this.documentiEqualtecResultProcess.push(d);
            } else {
              if (d.documentoWSDto.isNewRevisionPending) {
                this.isTabellaGuidelineRevisionPending = true;
              }
              this.documentiEqualtecResultGuideline.push(d);
            }
          }
          let index = 0;
          let indexCount = 0;
          d.documentoWSDto.metadatiDtoList.forEach(g => {
            if (g.key == "Sottoprocesso") {
              index = indexCount;
            }
            indexCount++;
          })
          d.documentoWSDto.metadatiDtoList.splice(index, 2);
          if (!this.isExternalDocumentType(d.identificazioneDocumento)) {
            if (total[d.identificazioneDocumento] == undefined) {
              total[d.identificazioneDocumento] = []
            }
            total[d.identificazioneDocumento].push(d);
          }
        });
        Object.keys(total).forEach(key => {
          const obj = {
            identificazioneDocumento: key, identificazioneDocumentoNum: 0, documentiEqualtecResultList: total[key], isTabellaAperta: false, isTabellaConUnElemento: false, isTabellaRevisionPending: false
          };
          this.tabelleProcessiIdentificazioneDocumento.push(obj)
        });
        this.tabelleProcessiIdentificazioneDocumento.forEach(d => {
          d.documentiEqualtecResultList.forEach(doc => {
            if (doc.documentoWSDto.isNewRevisionPending) {
              d.isTabellaRevisionPending = true;
              return;
            }
          })
          let count = 6;
          switch (d.identificazioneDocumento.toLowerCase()) {
            case "procedure":
              d.identificazioneDocumentoNum = 1;
              break;
            case "operative instruction":
              d.identificazioneDocumentoNum = 2;
              break;
            case "working instruction":
              d.identificazioneDocumentoNum = 3;
              break;
            case "template":
              d.identificazioneDocumentoNum = 4;
              break;
            case "record":
              d.identificazioneDocumentoNum = 5;
              break;
            default:
              d.identificazioneDocumentoNum = count;
              break;
          }
          count++;
        });
        this.tabelleProcessiIdentificazioneDocumentoOrdered = this.tabelleProcessiIdentificazioneDocumento.sort(function (a, b) { return a.identificazioneDocumentoNum - b.identificazioneDocumentoNum });
        this.documentiEqualtecResultBackup = this.documentiEqualtecResult;
      }
      this.labelNoRecord = true;
    }, error => console.error('error on get Processi di Riferimento', error));
  }

  resetSottoprocessiEdocumenti(nomeProcessoRiferimento) {
    this.isLegalentityTitleInterno = false;
    this.labelNoRecord = false;
    this.tabelleProcessiIdentificazioneDocumento = [];
    this.tabelleProcessiIdentificazioneDocumentoOrdered = [];
    this.documentiEqualtecResult = [];
    this.documentiEqualtecResultProcess = [];
    this.documentiEqualtecResultGuideline = [];
    this.documentiEqualtecResultBackup = [];
    this.documentiSottoprocessi = false;
    this.openProcess = true;
    this.openGuideline = true;
    this.sottoprocessi = [];
    this.docApertiGuideline = 0;
    this.docApertiProcess = 0;
    this.isExpandedGuideline = false;
    this.isTabellaGuidelineConUnElemento = false;
    this.isTabellaProcessConUnElemento = false;
    this.isExpandedProcess = false;
    this.isUnderlined = "";
    const url = 'api/rest/caricaSottoprocessiEdocumenti';
    const input = { processoRiferimento: nomeProcessoRiferimento, filtrolegalEntity: this.ngDropdown };  // Attenzione così gestisce un solo filtro. Per più di un filtro usare '#' come separatore filtri
    this.documentiEqualtecResultService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.documentiEqualtecResult = result as DocumentiEqualtecResult[];
        this.documentiEqualtecResult.forEach(d => {
          if (!this.isExternalDocumentType(d.identificazioneDocumento)) {
            let sottoprocessiList = [];
            sottoprocessiList = (d.nomeSottoprocesso || '').split(',').map(sottoprocesso => sottoprocesso.trim())
            sottoprocessiList.forEach(k => {
              if (k != "NA" && k != "" && k != null && k != undefined && !this.sottoprocessi.includes(k)) {
                this.sottoprocessi.push(k);
              }
            }
            )
          }
          d.documentoWSDto.metadatiDtoViewList = d.documentoWSDto.metadatiDtoShortList;
          d.documentoWSDto.apriDettaglio = "Open detail";
          if (this.isExternalDocumentType(d.identificazioneDocumento)) {
            if (d.identificazioneDocumento == "Process") {
              this.documentiEqualtecResultProcess.push(d);
            } else {
              this.documentiEqualtecResultGuideline.push(d);
            }
          }
          this.labelNoRecord = true;
        });
        let total = {}
        this.documentiEqualtecResult.forEach(f => {
          let index = 0;
          let indexCount = 0;
          f.documentoWSDto.metadatiDtoList.forEach(g => {
            if (g.key == "Sottoprocesso") {
              index = indexCount;
            }
            indexCount++;
          })
          f.documentoWSDto.metadatiDtoList.splice(index, 2);
          if (!this.isExternalDocumentType(f.identificazioneDocumento)) {
            if (total[f.identificazioneDocumento] == undefined) {
              total[f.identificazioneDocumento] = []
            }
            total[f.identificazioneDocumento].push(f);
          }
        });
        Object.keys(total).forEach(key => {
          const obj = { identificazioneDocumento: key, identificazioneDocumentoNum: 0, documentiEqualtecResultList: total[key], isTabellaAperta: false, isTabellaConUnElemento: false, isTabellaRevisionPending: false };
          this.tabelleProcessiIdentificazioneDocumento.push(obj)
        });
        this.tabelleProcessiIdentificazioneDocumento.forEach(d => {
          d.documentiEqualtecResultList.forEach(doc => {
            if (doc.documentoWSDto.isNewRevisionPending) {
              d.isTabellaRevisionPending = true;
              return;
            }
          })
          let count = 6;
          switch (d.identificazioneDocumento.toLowerCase()) {
            case "procedure":
              d.identificazioneDocumentoNum = 1;
              break;
            case "operative instruction":
              d.identificazioneDocumentoNum = 2;
              break;
            case "working instruction":
              d.identificazioneDocumentoNum = 3;
              break;
            case "template":
              d.identificazioneDocumentoNum = 4;
              break;
            case "record":
              d.identificazioneDocumentoNum = 5;
              break;
            default:
              d.identificazioneDocumentoNum = count;
              break;
          }
          count++;
        });
        this.tabelleProcessiIdentificazioneDocumentoOrdered = this.tabelleProcessiIdentificazioneDocumento.sort(function (a, b) { return a.identificazioneDocumentoNum - b.identificazioneDocumentoNum });
        this.documentiEqualtecResultBackup = this.documentiEqualtecResult;
      }
    }, error => console.error('error on get Processi di Riferimento', error));
  }

  visualizzaSottoprocessiEdocumenti(nomeSottoprocesso) {
    this.documentiSottoprocessi = true;
    this.tabelleProcessiIdentificazioneDocumento = [];
    this.isUnderlined = nomeSottoprocesso;
    this.documentiEqualtecResult = this.documentiEqualtecResultBackup;
    this.documentiEqualtecResult = this.documentiEqualtecResult.filter(d => {
      return !this.isExternalDocumentType(d.identificazioneDocumento) && this.documentBelongsToSubprocess(d, nomeSottoprocesso)
    });
    let total = {}
    this.documentiEqualtecResult.forEach(f => {
      if (total[f.identificazioneDocumento] == undefined) {
        total[f.identificazioneDocumento] = []
      }
      if (f.documentoWSDto.metadatiDtoList.length == 8) {
        f.documentoWSDto.metadatiDtoViewList.splice(3, 2);
      }
      total[f.identificazioneDocumento].push(f);
    });
    Object.keys(total).forEach(key => {
      const obj = { identificazioneDocumento: key, identificazioneDocumentoNum: 0, documentiEqualtecResultList: total[key], isTabellaAperta: false, isTabellaConUnElemento: false, isTabellaRevisionPending: false };
      this.tabelleProcessiIdentificazioneDocumento.push(obj)
    }
    );
    this.tabelleProcessiIdentificazioneDocumento.forEach(f => {
      f.documentiEqualtecResultList.forEach(d => {
        if (d.documentoWSDto.apriDettaglio == "Close detail") {
          d.documentoWSDto.metadatiDtoViewList = d.documentoWSDto.metadatiDtoShortList;
          d.documentoWSDto.apriDettaglio = "Open detail";
        }
      })
    })
    this.tabelleProcessiIdentificazioneDocumento.forEach(d => {
      d.documentiEqualtecResultList.forEach(doc => {
        if (doc.documentoWSDto.isNewRevisionPending) {
          d.isTabellaRevisionPending = true;
          return;
        }
      })
      let count = 6;
      switch (d.identificazioneDocumento.toLowerCase()) {
        case "procedure":
          d.identificazioneDocumentoNum = 1;
          break;
        case "operative instruction":
          d.identificazioneDocumentoNum = 2;
          break;
        case "working instruction":
          d.identificazioneDocumentoNum = 3;
          break;
        case "template":
          d.identificazioneDocumentoNum = 4;
          break;
        case "record":
          d.identificazioneDocumentoNum = 5;
          break;
        default:
          d.identificazioneDocumentoNum = count;
          break;
      }
      count++;
    });
    this.tabelleProcessiIdentificazioneDocumentoOrdered = this.tabelleProcessiIdentificazioneDocumento.sort(function (a, b) { return a.identificazioneDocumentoNum - b.identificazioneDocumentoNum });
    console.log("this.tabelleProcessiIdentificazioneDocumentoOrdered");
  }

  openCalendar = () => {
    this.isCalendar = !this.isCalendar;
  }

  selectDate = () => {
    let now = new Date();
    this.selectedDate = new Date(this.calendarModel.year, this.calendarModel.month - 1, this.calendarModel.day, now.getHours(), now.getMinutes(), 0, 0);
  }

  onResultClickedEvidenze = () => {
    if (this.DescrizioneEvidenza && this.OggettoEvidenza) {
      this.isOkDescrizione = true;
      this.isOkOggetto = true;
      this.isDetailSearchEvidenze = true; // ?????????   
      let selectedDateString = "";
      if (this.selectedDate != null && this.selectedDate != undefined) {
        selectedDateString = this.selectedDate.toDateString();
      } else {
        selectedDateString = "";
      }
      const send = this.showResultEvidenze(this.DescrizioneEvidenza, this.OggettoEvidenza, this.paginaIDDocumentoCorrente, this.paginaCommittenteDocumentoCorrente, selectedDateString);
      return send;
    } else {
      if (!this.DescrizioneEvidenza && this.OggettoEvidenza) {
        this.isOkDescrizione = false;
        this.isOkOggetto = true;
      }
      if (this.DescrizioneEvidenza && !this.OggettoEvidenza) {
        this.isOkOggetto = false;
        this.isOkDescrizione = true;
      }
      if (!this.DescrizioneEvidenza && !this.OggettoEvidenza) {
        this.isOkOggetto = false;
        this.isOkDescrizione = false;
      }
    }
  }

  aggiungiAiPreferiti = (idDocumento, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "link": {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = true;
          }
        })
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Added");
          }
        })
        break;
      }
      case "preferiti": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = true;
          }
        })
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Added");
          }
        })
        break;
      }
      case "search": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = true;
          }
        })
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Added");
          }
        })
        break;
      }
      case "process": {
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {

            doc.documentoWSDto.isDocPreferito = true;
          }
        })
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Added");
          }
        })
        break;
      }
      case "guideline": {
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.isDocPreferito = true;
          }
        })
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Added");
          }
        })
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.isDocPreferito = true;
              }
            })
            const url = 'api/rest/SetDocumentiPreferiti';
            const input = { idDocumento };
            this.documentService.postData(url, input, false).subscribe(result => {
              if (result) {
                console.log("Preferite " + idDocumento + " Added");
              }
            })
          }
        })
        break;
      }
    }
  }

  togliDaiPreferiti = (idDocumento, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "link": {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        })
        break;
      }
      case "search": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        })
        break;
      }
      case "preferiti": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        })
        break;
      }
      case "process": {
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {

            doc.documentoWSDto.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        })
        break;
      }
      case "guideline": {
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        })
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.isDocPreferito = false;
              }
            })
            const url = 'api/rest/UnSetDocumentiPreferiti';
            const input = { idDocumento };
            this.documentService.postData(url, input, false).subscribe(result => {
              if (result) {
                console.log("Preferite " + idDocumento + " Unset");
              }
            })
          }
        })
        break;
      }
    }
  }

  showResultEvidenze = (DescrizioneEvidenza: string, OggettoEvidenza: string, iddocumento: string, destinatarioEvidenza: string, dataScadenza: string) => {
    this.labelNoRecord = false;
    const url = 'api/rest/CreaEvidenza';
    const input = { descrizione: DescrizioneEvidenza, oggetto: OggettoEvidenza, iddocumento: iddocumento, destinatari: destinatarioEvidenza, datascadenza: dataScadenza };
    this.creaEvidenzaService.postData(url, input, false).subscribe(result => {
      if (result['risultato'] == "OK") {
        this.OggettoEvidenza = "";
        this.DescrizioneEvidenza = "";
        this.isCalendar = false;
        console.log("result" + result)
        alert("Evidence created");
        /* Refresh della lista Evidenze */
        const url = 'api/rest/GetEvidenzeByIdDocumento';
        const input = { iddocumento: iddocumento };
        this.evidenzaService.postData(url, input, false).subscribe(result => {
          if (result) {
            this.evidenze = result as Evidenza[];
            this.labelNoRecord = true;
            this.myInputVariable.nativeElement.value = "";
          }
        })
      } else {
        alert("an error occurred during the creation of the evidence");
      }
    })
  }

  onFileSelected(event) {
    this.buttonEvidenzaActive = false;
    const file: File = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("thumbnail", file);
      formData.append("iddocumento", this.paginaIDDocumentoCorrente);
      const upload$ = this.http.post("/api/rest/thumbnail-upload", formData);
      upload$.subscribe(result => {
        this.buttonEvidenzaActive = true;
      }, error => {
        alert("Errore durante l'upload del file");
        this.buttonEvidenzaActive = true;
      });
    }
  }

  tabMenuAllegato = (codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "search": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.ismenuAllegato = !doc.ismenuAllegato;
            const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
            doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        })
        break;
      }
      case "preferiti": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.ismenuAllegato = !doc.ismenuAllegato;
            const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
            doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        })
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.ismenuAllegato = !doc.ismenuAllegato;
            const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
            doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        })
        break;
      }
      case "process": {
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.ismenuAllegato = !doc.documentoWSDto.ismenuAllegato;
            const splitAll = doc.documentoWSDto.allegatoPrimarioDto.nomeFile.split('.');
            doc.documentoWSDto.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        })
        break;
      }
      case "guideline": {
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.ismenuAllegato = !doc.documentoWSDto.ismenuAllegato;
            const splitAll = doc.documentoWSDto.allegatoPrimarioDto.nomeFile.split('.');
            doc.documentoWSDto.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        })
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.ismenuAllegato = !doc.documentoWSDto.ismenuAllegato;
                const splitAll = doc.documentoWSDto.allegatoPrimarioDto.nomeFile.split('.');
                doc.documentoWSDto.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
              }
            })
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }

  tabMenuAllegatoSecondario = (codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {

    switch (tipoDiTabella) {
      case "search": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.ismenuAllegatoSecondario = !doc.ismenuAllegatoSecondario;
            doc.allegatiSecondariDtoList.forEach(all => {
              all.isTabVisualizated = true;
              all.isTabOpened = false;
              const splitAll = all.nomeFile.split('.');
              all.estensione = splitAll[splitAll.length - 1];
            })
          }
        })
        break;
      }
      case "preferiti": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.ismenuAllegatoSecondario = !doc.ismenuAllegatoSecondario;
            doc.allegatiSecondariDtoList.forEach(all => {
              all.isTabVisualizated = true;
              all.isTabOpened = false;
              const splitAll = all.nomeFile.split('.');
              all.estensione = splitAll[splitAll.length - 1];
            })
          }
        })
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.ismenuAllegatoSecondario = !doc.ismenuAllegatoSecondario;
            doc.allegatiSecondariDtoList.forEach(all => {
              all.isTabVisualizated = true;
              all.isTabOpened = false;
              const splitAll = all.nomeFile.split('.');
              all.estensione = splitAll[splitAll.length - 1];
            })
          }
        })
        break;
      }
      case "process": {
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.ismenuAllegatoSecondario = !doc.documentoWSDto.ismenuAllegatoSecondario;
            doc.documentoWSDto.allegatiSecondariDtoList.forEach(all => {
              all.isTabVisualizated = true;
              all.isTabOpened = false;
              const splitAll = all.nomeFile.split('.');
              all.estensione = splitAll[splitAll.length - 1];
            })
          }
        })
        break;
      }
      case "guideline": {
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.ismenuAllegatoSecondario = !doc.documentoWSDto.ismenuAllegatoSecondario;
            doc.documentoWSDto.allegatiSecondariDtoList.forEach(all => {
              all.isTabVisualizated = true;
              all.isTabOpened = false;
              const splitAll = all.nomeFile.split('.');
              all.estensione = splitAll[splitAll.length - 1];
            })
          }
        })
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.ismenuAllegatoSecondario = !doc.documentoWSDto.ismenuAllegatoSecondario;
                doc.documentoWSDto.allegatiSecondariDtoList.forEach(all => {
                  all.isTabVisualizated = true;
                  all.isTabOpened = false;
                  const splitAll = all.nomeFile.split('.');
                  all.estensione = splitAll[splitAll.length - 1];
                  console.log("estensione ");
                  console.log(all.estensione);
                })
              }
            })
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }

  tabMenuAllegatoSecondarioList = (codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella, allegatoSecondario) => {
    switch (tipoDiTabella) {
      case "search": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile == allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }
            })
          }
        })
        break;
      }
      case "preferiti": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile == allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }
            })
          }
        })
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile == allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }

            })
          }
        })
        break;
      }
      case "process": {
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {

            doc.documentoWSDto.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile == allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }
            })
          }
        })
        break;
      }
      case "guideline": {
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile == allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }
            })
          }
        })
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.allegatiSecondariDtoList.forEach(all => {
                  if (all.nomeFile == allegatoSecondario) {
                    all.isTabOpened = !all.isTabOpened;
                  } else {
                    all.isTabVisualizated = !all.isTabVisualizated;
                  }

                })
              }
            })
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }

  internalGetFullYear = (d) => {
    this.srch = null;
    return new Date().getFullYear()
  }
  dataURIToBlob = (dataURI, mimeString) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

  getArcadocAttach(item: AttachmentDto, iddocumento, download: boolean) {
    this.labelNoRecord = false;

    let url = 'api/rest/GetAttachment';
    let params = { params: { idAllegato: item.idAllegato, idDocument: iddocumento, fileName: item.nomeFile, download: download } };
    this.fileServer.getData(url, params, false).toPromise().then(res => {
      let attachment: AttachmentDto = res as AttachmentDto;
      let ext = attachment.nomeFile.split('.').pop();
      const downloadLink = document.createElement("a");
      const fileName = attachment.nomeFile;
      this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob => {
        let url = URL.createObjectURL(blob);
        if (download) {
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
        } else {
          window.open(url, '_blank')
        }
        this.labelNoRecord = true;

      })
    });
  }
}
